import React from 'react';
import { Box, Typography } from '@mui/material';
import ApiParametersTable from '../ApiParametersTable';
import ApiEndpointDisplay from '../ApiEndpointDisplay';
import ApiResponseExamples from '../ApiResponseExamples';
import ApiRequestExamples from '../ApiRequestExamples';

const CameraDetailsApi: React.FC = () => {
    const parameters = [
        { type: 'HEAD', name: 'Authorization', dataType: 'string', required: true },
        { type: 'POST', name: 'vehicleId', dataType: 'string', required: true },
    ];

    return (
        <Box className="flex flex-col border-b border-gray-200">
            <Typography variant="h6" marginBottom={1} fontWeight={600} fontSize={16} id="camera-details">
                GET ALL CAMERA TYPE BY VEHICLE NUMBER
            </Typography>
            
            <Typography variant='body2' marginBottom={2} fontSize={14} fontWeight={400}>
                To retrieve all camera details for a specific vehicle, you must send a POST request. This request requires an Authorization token in the headers and a request body containing the details of the vehicle you want to fetch camera details for.
            </Typography>
            <Typography variant='body2' marginBottom={1} fontSize={14} fontWeight={600}>Request</Typography>
            <ApiEndpointDisplay 
                method="POST" 
                url="https://backend.novusomnifleet.com/api/client/v1/fetch-all-camera" 
            />

            <ApiParametersTable parameters={parameters} />

            <Typography variant="body2" fontSize={14} fontWeight={400} mb={2}>
                    In request body, send the vehicleId of the vehicle you want to fetch the camera details for.
            </Typography>

            <ApiRequestExamples
                examples={[
                    {
                    type: "headers",
                    headers: [
                        {
                        key: "Authorization",
                        value:
                            "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJJQ1NBIiwidXNlcklkIjoiNjdkOTBkMDdlNGNhZTU3MDEwMzQyYzA4Iiwicm9sZXMiOiJST0xFX0ZMRUVUX01BTkFHRVIiLCJpYXQiOjE3NTQzNzIyNjksImV4cCI6MTc1NDQwODI2OX0.NItAkAwXNGKxoAsUTZSwB0lzFPHgW3I4ZwpLEY4c-Lo"
                        }
                    ],
                    label: "Request Headers"
                    },
                    {
                    type: "body",
                    contentType: "json",
                    value: `{
 "vehicleId": "testing346430119485"
}`,
                    label: "Request Body"
                    }
                ]}
            />

            <ApiResponseExamples 
                examples={[
                    {
                        status: '200',
                        description: 'Success',
                        response: `{
                                    "data": [
                                      {
                                        "cameraId": "2",
                                        "cameraName": "DMS"
                                      },
                                      {
                                        "cameraId": "1",
                                        "cameraName": "ADAS"
                                      }
                                    ],
                                    "message": "Camera Details Fetched Successfully",
                                    "status": 200
                                  }`
                    },
                    {
                        status: '400',
                        description: 'Missing vehicleId',
                        response: `{
                                      "success": false,
                                      "message": "Invalid request body",
                                      "errors": [
                                        {
                                          "code": "missing_field",
                                          "field": "vehicleId",
                                          "detail": "VehicleId is required"
                                        }
                                      ]
                                    }`
                    },
                    {
                        status: '401',
                        description: 'Unauthorized',
                        response: `{
                                      "success": false,
                                      "message": "Invalid username or password"
                                    }`
                    },
                    {
                        status: '500',
                        description: 'Server Error',
                        response: `{
                                      "success": false,
                                      "message": "An internal server error occurred"
                                    }`
                    }
                ]}
            />
          </Box>
    );
};

export default CameraDetailsApi;
